// Adapts one row of the mock-exam /review payload to the shape resolveLeafVerdict expects.
// Shared by StudentMockExamReview and StudentMockExamReport so both pages read one verdict.
export const toMockLeafRow = (q, parent) => ({
  marks: q.marks,
  // The /review payload spells the verdict `isCorrect`, while /verify-answers spells it
  // `is_correct` — and the resolver reads the snake_case form. Without the fallback it saw no
  // server verdict at all on review and re-derived one from strings.
  is_correct: q.is_correct ?? q.isCorrect ?? null,
  is_partial: q.is_partial,
  partial_ratio: q.partial_ratio,
  your_answer: q.submitted_answer ?? q.your_answer,
  // The server knows whether anything was submitted (incl. {blanks, interactive} and matching
  // maps); without it a typed answer with no flat text read as "Not answered".
  answered: typeof q.answered === 'boolean' ? q.answered : undefined,
  correct_answer_label: Array.isArray(q.correct_answer)
    ? q.correct_answer.join(' | ')
    : (q.correct_answer ?? q.correct_answer_label),
  question_text: q.question_text ?? q.question ?? parent?.question_text ?? parent?.question,
  question_type: q.type ?? q.question_type,
  question_id: q.id,
  your_answer_interactive: q.your_answer_interactive,
  your_answer_drawing: q.submitted_drawing ?? q.your_answer_drawing,
  exact_match: q.exact_match ?? q.answer_data?.exact_match,
  answer_rule: q.answer_rule ?? q.answer_data?.answer_rule,
  answer_data: q.answer_data,
  selected_index: q.selected_index,
  scan_note: q.scan_note,
});
